import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79fe5420&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=79fe5420&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe5420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79fe5420')) {
      api.createRecord('79fe5420', component.options)
    } else {
      api.reload('79fe5420', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79fe5420&scoped=true", function () {
      api.rerender('79fe5420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/releaseManage/index.vue"
export default component.exports